import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Page } from "src/app/util/page";
import { NeedaConfig } from "./needa-config";
import { SearchRequest } from "./search-request";
import { Supplier } from "./supplier";

@Injectable()
export class SupplierService {
  constructor(private httpClient: HttpClient) {

  }

  public findById(id: string): Observable<Supplier> {
    return this.httpClient.get<Supplier>("/api/supplier/" + id);
  }

  public findAll(searchRequest: SearchRequest, page: number, size: number): Observable<Page<Supplier>> {
    return this.httpClient.post<Page<Supplier>>(`/api/supplier?search&page=${page}&size=${size}&sort=name,ASC`, searchRequest);
  }

  public findNameLike(name: string): Observable<Page<string>> {
    return this.httpClient.get<Page<string>>(`/api/supplier?name=${name}`);
  }

  public search(searchRequest: SearchRequest): Observable<Page<Supplier>> {
    return this.httpClient.post<Page<Supplier>>(`/api/supplier?search`, searchRequest);
  }

  public findNeedaConfig(supplierId: string): Observable<NeedaConfig> {
    return this.httpClient.get<NeedaConfig>(`/api/supplier/${supplierId}/needa-config`);
  }
}